export default "__VITE_ASSET__60c3de7c__"